import React from 'react'
import { Alert, Center } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'

export const AdvancedReporting = () => {
    return (
        <Center>
            <Alert w={600} icon={<IconInfoCircle />} variant='light' color='blue' title="Coming Soon!">
                This feature is still in development.
            </Alert>
        </Center>
    )
}